<template>
  <div class="pt-vod w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 px-0">
          <div class="container-fluid">
            <!-- player -->
            <!-- add balik v-if="!lockPlayer" klu nk lock balik -->
            <div class="row justify-content-center p-0 p-xl-4">
              <div class="col-12 px-0">
                <div
                  class="w-100 d-flex"
                  style="max-width: 1190px;margin: 0 auto;"
                >
                  <div class="embed-responsive embed-responsive-16by9">
                    <div
                      id="vidBox"
                      class="player embed-responsive-item"
                      ref="vidBox"
                    ></div>
                    <!-- <iframe
                      class="player embed-responsive-item"
                      :src="
                        `https://rtm-player.glueapi.io/latest/h/${playerId}?token=${token}`
                      "
                      frameborder="0"
                      allowfullscreen
                    ></iframe> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- locked player -->
            <!-- uncomment klu nk lock balik -->
            <!-- <div class="row" v-else>
              <div class="col-12 px-0">
                <div
                  class="w-100 d-flex justify-content-center position-relative"
                >
                  <div
                    class="embed-responsive embed-responsive-16by9"
                    style="max-width: 1190px;"
                  >
                    <img
                      class="player embed-responsive-item"
                      :src="lockPlayerBgImage"
                      alt=""
                    />
                  </div>
                  <div class="lock-icon-on-player">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="80" height="80" rx="40" fill="#D9E021" />
                      <path
                        d="M28.5714 60C27.5238 60 26.6267 59.6267 25.88 58.88C25.1333 58.1333 24.7606 57.2368 24.7619 56.1905V37.1429C24.7619 36.0952 25.1352 35.1981 25.8819 34.4514C26.6286 33.7048 27.5251 33.3321 28.5714 33.3333H30.4762V29.5238C30.4762 26.8889 31.4051 24.6425 33.2629 22.7848C35.1206 20.927 37.3663 19.9987 40 20C42.6349 20 44.8813 20.9289 46.739 22.7867C48.5968 24.6444 49.5251 26.8902 49.5238 29.5238V33.3333H51.4286C52.4762 33.3333 53.3733 33.7067 54.12 34.4533C54.8667 35.2 55.2394 36.0965 55.2381 37.1429V56.1905C55.2381 57.2381 54.8648 58.1352 54.1181 58.8819C53.3714 59.6286 52.4749 60.0013 51.4286 60H28.5714ZM28.5714 56.1905H51.4286V37.1429H28.5714V56.1905ZM40 50.4762C41.0476 50.4762 41.9448 50.1029 42.6914 49.3562C43.4381 48.6095 43.8108 47.713 43.8095 46.6667C43.8095 45.619 43.4362 44.7219 42.6895 43.9752C41.9429 43.2286 41.0463 42.8559 40 42.8571C38.9524 42.8571 38.0552 43.2305 37.3086 43.9771C36.5619 44.7238 36.1892 45.6203 36.1905 46.6667C36.1905 47.7143 36.5638 48.6114 37.3105 49.3581C38.0571 50.1048 38.9537 50.4775 40 50.4762ZM34.2857 33.3333H45.7143V29.5238C45.7143 27.9365 45.1587 26.5873 44.0476 25.4762C42.9365 24.3651 41.5873 23.8095 40 23.8095C38.4127 23.8095 37.0635 24.3651 35.9524 25.4762C34.8413 26.5873 34.2857 27.9365 34.2857 29.5238V33.3333Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- details -->
            <div class="row details_wrapper">
              <div class="col-12 p-3 p-md-4">
                <div
                  class="w-100 d-flex justify-content-start align-items-center flex-wrap"
                >
                  <span
                    class="drama-title text-left"
                    v-if="player_details.longTitle"
                    >{{ player_details.longTitle }}</span
                  >
                  <!-- <span class="drama-episode">&nbsp;Episode 1</span> -->
                </div>
                <div
                  class="w-100 d-flex justify-content-start align-items-center mt-3"
                  v-if="showClassification"
                >
                  <div class="category-wrapper mr-1" v-if="showClassification">
                    <span>{{
                      player_details.data.classification.title.en_US
                    }}</span>
                  </div>
                  <!-- <span class="small-text border-left border-right mx-2 px-2"
                    >2021</span
                  >
                  <span class="small-text"
                    >Dikemas kini kepada 29/Jumlah 40 Episod</span
                  > -->
                </div>
                <div
                  class="w-100 d-flex justify-content-start align-items-center mt-3"
                  v-if="showCategories"
                >
                  <!-- <span class="gray-small-title">Genre&nbsp;:&nbsp;</span> -->
                  <span class="small-text">{{
                    player_details.data.categories[0].title.en_US
                  }}</span>
                </div>
                <div
                  class="w-100 d-flex justify-content-start align-items-start mt-3"
                  v-if="player_details.data && player_details.data.description"
                >
                  <!-- <span class="gray-small-title">Sinopsis&nbsp;:&nbsp;</span> -->
                  <span class="small-text">
                    {{ player_details.data.description }}
                  </span>
                </div>
                <div
                  class="w-100 d-flex justify-content-start align-items-start mt-3 flex-wrap"
                  v-if="isShowingCast"
                >
                  <span class="gray-small-title">Pelakon&nbsp;:&nbsp;</span>

                  <span
                    class="small-text"
                    v-for="(item, idx) in pelakon"
                    :key="idx"
                  >
                    {{ item.actor.title.en_US
                    }}<span v-if="idx >= 0 && idx < pelakon.length - 1"
                      >,&nbsp;</span
                    >
                  </span>
                </div>
                <div
                  class="w-100 d-flex justify-content-start align-items-start mt-3"
                  v-if="isShowingProductionYear"
                >
                  <span class="gray-small-title"
                    >Tarikh Disunting&nbsp;:&nbsp;</span
                  >
                  <span class="small-text">
                    {{ production_year }}
                  </span>
                </div>
                <!-- add balik v-if="!lockPlayer" klu nk lock balik -->
                <div class="w-100 d-flex justify-content-start mt-3">
                  <div class="buttonWrapper mr-2" v-if="authenticated">
                    <div
                      class="icon cursor-pointer"
                      v-if="isFavoriteActive"
                      @click="removeFavorite()"
                    >
                      <img
                        src="../assets/rtmklik/icon_active_favorite.svg"
                        alt="play icon"
                      />
                    </div>
                    <div
                      class="icon cursor-pointer"
                      @click="setFavorite()"
                      v-else
                    >
                      <img
                        src="../assets/rtmklik/main-like.svg"
                        alt="play icon"
                      />
                    </div>
                    <p class="d-none d-lg-block mb-0 label ml-2">Kegemaran</p>
                  </div>
                  <div class="buttonWrapper mr-2" @click="openModal()">
                    <div class="icon cursor-pointer">
                      <img
                        src="../assets/rtmklik/main-share.svg"
                        alt="play icon"
                      />
                    </div>
                    <p class="d-none d-lg-block mb-0 label ml-2">Kongsi</p>
                  </div>
                  <social ref="social"></social>
                </div>
                <!-- uncomment balik klu nk lock balik -->
                <!-- <div class="mt-4" v-else>
                  <div class="login-lock-wrapper" @click="goTo('/login')">
                    <p class="mb-0 login-lock-button">
                      Log masuk untuk tonton
                    </p>
                  </div>
                </div> -->
              </div>
            </div>

            <!-- pagination for berita and periodic -->
            <div
              class="row"
              v-if="episodes_list.length > 0 && isShowingPagination"
            >
              <!-- for berita and periodic in desktop -->
              <div class="col-12">
                <div class="row my-4 px-1 px-md-4">
                  <div
                    v-for="item in episodes_list"
                    :key="item.id"
                    class="col-6 col-sm-4 col-md-2 p-2"
                  >
                    <vodCardWithoutHover
                      :image="item.img_link"
                      :title="item.longTitle"
                      :link="item.redirect_link"
                    />
                  </div>
                  <div class="col-12 px-0 mt-3">
                    <vue-paginate-al
                      :totalPage="totalPage"
                      @btnClick="goToFunction"
                      :nextText="'>'"
                      :prevText="'<'"
                    ></vue-paginate-al>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row d-none d-md-flex"
              v-if="episodes_list.length > 0 && isShowingProgramOnly"
            >
              <div class="col-12">
                <div class="row my-4 px-1 px-md-4 ">
                  <EpisodeList :data="episodes_list" :lockedlist="lockPlayer" />
                </div>
              </div>
            </div>
            <div class="row" v-else></div>
            <!-- ads -->
            <div class="row">
              <!-- <div class="col-12"> -->
              <!-- <billboardBannerTop v-if="desktop"></billboardBannerTop>
                <mrecBannerTop v-if="mobile"></mrecBannerTop> -->
              <!-- <MaintainanceDesktop />
                <MaintainanceMobile /> -->
              <!-- </div> -->

              <!-- <div class="col-12">
                <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
              </div> -->
            </div>
            <!-- recommendation -->
            <div
              class="row mt-5 d-none d-md-flex"
              v-if="isShowingProgramOnly || isMovieOrSport"
            >
              <div class="col-12 px-2 px-4">
                <!-- enable yg ni balik nnti bila nk add recommendation rails, and remove yg bawah -->
                <!-- <RecommendationRails
                  :class="{
                    'belt-margin-bottom-for-players': !initializeRecommendation,
                  }"
                /> -->
                <RecommendationRails class="belt-margin-bottom-for-players" />
              </div>
            </div>
            <!-- <div class="row mt-1" v-if="initializeRecommendation">
              <div class="col-12 px-3 px-md-4">
                <PlayerRecommendation
                  class="my-2 my-md-4"
                  :contentID="playerId"
                />
              </div>
              <div class="col-12 mt-4 mt-md-2 px-3 px-md-4">
                <PlayerRecommendation1
                  class="my-2 my-md-4"
                  :contentID="playerId"
                  :title="active_program_title"
                />
              </div>
              <div class="col-12 mt-4 mt-md-2 px-3 px-md-4">
                <PlayerRecommendation2
                  class="my-2 my-md-4"
                  :contentID="playerId"
                  :title="active_program_title"
                />
              </div>
            </div> -->

            <div
              class="w-100 my-4 d-flex d-md-none"
              v-if="episodes_list.length > 0 && isShowingProgramOnly"
            >
              <PlayerTabsMobile
                :episodeData="episodes_list"
                :lockedlist="lockPlayer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div
    v-else
    style="min-height: 70vh; display: flex; align-items: center;justify-content: center;color: white;"
  >
    <p>loading</p>
  </div> -->
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import vodCardWithoutHover from "../components/cards/v2/vodCardWithoutHover.vue";
import noimage from "../assets/noimage.png";
import social from "../components/popup/sharepopup";
import { mapGetters } from "vuex";
import { bus } from "../main";
import axios from "axios";
// ads
// import billboardBannerTop from "../components/ads/billboardBannerTop";
// import mrecBannerTop from "../components/ads/mrecBannerTop";
// import billboardbannerbottom from "../components/ads/billboardBannerBottom";
// import mrecbannerbottom from "../components/ads/mrecBannerBottom";
import RecommendationRails from "../components/carousel/recommendation/recommendationRails.vue";
import EpisodeList from "../components/carousel/player/v2/episodeList.vue";
import PlayerTabsMobile from "../components/common/playerTabsMobile.vue";
// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";
import PlayerRecommendation from "../components/carousel/player/v2/recommendation/recommendation.vue";
import PlayerRecommendation1 from "../components/carousel/player/v2/recommendation/recommendation1.vue";
import PlayerRecommendation2 from "../components/carousel/player/v2/recommendation/recommendation2.vue";

const customLabels = {
  first: "",
  last: "",
  previous: "Previous",
  next: "Next",
};

export default {
  components: {
    social,
    // billboardBannerTop,
    // mrecBannerTop,
    // billboardbannerbottom,
    // mrecbannerbottom,
    RecommendationRails,
    // MaintainanceDesktop,
    // MaintainanceMobile,
    vodCardWithoutHover,
    EpisodeList,
    PlayerTabsMobile,
    PlayerRecommendation,
    PlayerRecommendation1,
    PlayerRecommendation2,
  },
  data: function() {
    return {
      leftColStyles: {},
      epsColStyles: {},
      showepisodelist: true,
      window: {
        width: 0,
        height: 0,
      },
      share: [],
      url: "",
      childDataLoaded: false,
      showModal: false,
      tablet: false,
      mobile: false,
      desktop: false,
      playerType: this.$route.params.type,
      programSlug: this.$route.params.program_id,
      episodeSlug: this.$route.params.episode_id,
      programId: this.$route.params.program_id,
      episodeId: this.$route.params.episode_id,
      playerId: "",
      show_episodes: false,
      player_details: [],
      pelakon: [],
      production_year: "",
      episodes_list: [],
      active_program_id: "", // Content ID from content api response
      active_program_title: "",
      active_episode_id: "",
      active_episode_title: "",
      loads: false,
      token: localStorage.getItem("token"),
      showClassification: false,
      showCategories: false,
      isShowingCast: false,
      isShowingProductionYear: false,
      isShowingDescription: false,
      customLabels,
      pageOfItems: [],
      limit: 18,
      offset: 0,
      totalEpisodeCount: 0,
      totalPage: "",
      isShowingPagination: false,
      isShowingProgramOnly: false,
      isFavoriteActive: false,
      isFavoriteIcon: "../assets/rtmklik/main-like.svg",
      isMovieOrSport: false,
      lockPlayer: false, //this is for exclusive where we lock the player
      lockPlayerBgImage: "",
      initializeRecommendation: false,
    };
  },
  created: function() {},
  methods: {
    goToFunction: function(n) {
      this.getEpisodeByLimit(n);
    },

    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },

    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    openModal() {
      var link_url = window.location.origin + this.$route.fullPath;
      this.share = {
        url: link_url,
        title: this.active_episode_title,
      };

      bus.$emit("shareVar", this.share);
      this.$refs.social.show();
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },
    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    handleResize() {
      this.window.width = window.innerWidth;
      var heightString = this.$refs.vidBox.clientHeight;
      var vidDetailsString = this.$refs.vidDetails.clientHeight;
      var result = heightString + vidDetailsString + "px";
      var eps_result = (result - 70) / 3 + "px";
      if (this.window.width <= "991") {
        Vue.set(this.leftColStyles, "height", "300px");
      } else {
        Vue.set(this.leftColStyles, "height", result);
        Vue.set(this.epsColStyles, "height", eps_result);
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.settings.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },

    initializeProgramcontentview() {
      var self = this;

      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-Auth-Token": `${self.token}`,
        },
        data: JSON.stringify({
          idContent: self.active_program_id, // Content ID from content api response
          contentTitle: self.active_program_title, // Content Longtitle from content api response
          site: "RTMKlik",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          //console.log(data);
        },
        failure: function(errMsg) {
          //console.log(errMsg);
        },
      });
    },
    initializeEpisodeContentview() {
      var self = this;
      var token = localStorage.getItem("token");

      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-Auth-Token": `${self.token}`,
        },
        data: JSON.stringify({
          idContent: self.active_episode_id, // Content ID from content api response
          contentTitle: self.active_episode_title, // Content Longtitle from content api response
          site: "RTMKlik",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          //console.log(data);
        },
        failure: function(errMsg) {
          //console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "vodplayer",
          site: "RTMKlik",
          referrer: "Direct",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          // console.log(errMsg);
        },
      });
    },

    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    assignDetailsWithoutEps(obj) {
      this.player_details = obj;

      // chaining for classification,categories
      const relatedData = this.player_details.data;
      this.showClassification =
        relatedData &&
        relatedData.classification &&
        relatedData.classification.title &&
        relatedData.classification.title.en_US
          ? true
          : false;

      this.showCategories =
        relatedData &&
        relatedData.categories[0] &&
        relatedData.categories[0].title &&
        relatedData.categories[0].title.en_US
          ? true
          : false;

      // if(this.player_details.)
      let program_id = this.programId;

      // for reporting
      if (this.playerType == "movie" || this.playerType == "sport") {
        this.active_program_id = this.programId;
        this.active_program_title = obj.longTitle;
        this.initializeProgramcontentview();
      } else if (
        this.playerType == "program" ||
        this.playerType == "news" ||
        this.playerType == "periodic"
      ) {
        let title = obj.data[this.playerType].title;

        this.active_program_id = this.programId;
        this.active_program_title = title;
        this.active_episode_id = this.episodeId;
        this.active_episode_title = obj.longTitle;

        this.initializeProgramcontentview();
        this.initializeEpisodeContentview();
      }

      this.initializepageview();

      try {
        axios
          .get(`https://rtm.glueapi.io/v3/content/${program_id}`)
          .then((response) => {
            // this.getEpisodesList(response.data.data);

            if (this.playerType === "news" || this.playerType === "periodic") {
              this.isShowingPagination = true;

              this.getEpisodeByLimit(1);
            } else if (this.playerType === "program") {
              this.isShowingProgramOnly = true;
              this.getEpisodeForProgramNotNewsOrPeriodic();
            }

            this.getCastAndProductionYear(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    async pushFirstEpsID(obj) {
      this.player_details = obj;
      let object_key, apiUrl;

      if (this.playerType == "program") {
        object_key = "program_episode";
        apiUrl = `https://rtm.glueapi.io/v3/content/${
          obj[object_key][0].id
        }?fields=slug`;
      } else if (this.playerType == "news") {
        object_key = "news_episode";
        apiUrl = `https://rtm.glueapi.io/v3/content/${
          obj[object_key][0].id
        }?fields=slug`;
      } else if (this.playerType == "periodic") {
        if (obj && obj["periodic_episode"]) {
          object_key = "periodic_episode";
          apiUrl = `https://rtm.glueapi.io/v3/content/${
            obj[object_key][0].id
          }?fields=slug`;
        } else {
          object_key = "periodic";
          apiUrl = `https://rtm.glueapi.io/v3/content/${
            obj["periodic"].id
          }?fields=slug`;
        }
      }

      if (object_key != "periodic") {
        obj[object_key].sort(function(a, b) {
          return b.id - a.id;
        });
      }

      const response = await axios.get(apiUrl);

      let first_eps = response.data.slug;

      let link = `/play/${this.playerType}/${this.programSlug}/${first_eps}`;
      this.goTo(link);
    },

    getCastAndProductionYear(obj) {
      this.isShowingCast =
        obj && obj.cast && obj.cast.length !== 0 ? true : false;

      let castStore = [];

      if (this.isShowingCast) {
        obj.cast.forEach((items) => {
          if (
            items.actor &&
            items.actor.title &&
            items.actor.title["en_US"] !== ""
          ) {
            castStore.push(items);
          }
        });
        this.pelakon = castStore;
      }

      this.isShowingProductionYear =
        obj && obj.production_year && obj.production_year[0].length !== 0
          ? true
          : false;

      if (this.isShowingProductionYear) {
        this.production_year = obj.production_year[0].title.en_US;
      }
    },

    getEpisodeByLimit(n) {
      const limit = this.limit;
      const offset = n === 1 ? 0 : (n - 1) * this.limit;
      // https://rtm.glueapi.io/v1/content?idParents=5172
      try {
        axios
          .get(
            `https://rtm.glueapi.io/v1/content?idParents=${
              this.active_program_id
            }&fields=title,slug,data.image&limit=${limit}&offset=${offset}`
          )
          .then((response) => {
            this.totalEpisodeCount = response.data.count;
            this.organizeEpisodesList(response.data.data);
            this.offset = this.offset + 18;
            // console.log("testing", (page - 1) * itemsPerPage + 1);
            this.totalPage = Math.ceil(this.totalEpisodeCount / this.limit);
          });
      } catch (e) {
        console.log(e);
      }
    },
    organizeEpisodesList(obj) {
      let store = obj;
      store.forEach((element, idx) => {
        let eps_slug_name = element.slug;
        element["redirect_link"] = `/play/${this.playerType}/${
          this.programSlug
        }/${eps_slug_name}`;

        if (element.data && element.data.images) {
          element["img_link"] = this.rtmImgLinkFiltering(
            element.data.images,
            "320x0"
          );
        } else {
          element["img_link"] = "";
        }
      });
      this.episodes_list = store;
    },
    getEpisodeForProgramNotNewsOrPeriodic() {
      try {
        axios
          .get(
            `https://rtm.glueapi.io/v1/content?idParents=${
              this.active_program_id
            }&fields=title,slug,data.image,data.description&limit=100`
          )
          .then((response) => {
            this.organizeEpisodesList(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    async getEpisodesList(obj) {
      let object_key;
      let store = [];
      if (this.playerType == "program") {
        object_key = "program_episode";
      } else if (this.playerType == "news") {
        object_key = "news_episode";
      } else if (this.playerType == "periodic") {
        object_key = "periodic_episode";
      }

      if (obj) {
        obj[object_key].sort(function(a, b) {
          return b.id - a.id;
        });
      }

      store = obj[object_key];

      this.episodes_list = store;
    },
    getDetailsWithoutEps(id) {
      try {
        axios
          .get(`https://rtm.glueapi.io/v3/content/${id}`)
          .then((response) => {
            this.assignDetailsWithoutEps(response.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getDetailsWithEps(id) {
      try {
        axios
          .get(`https://rtm.glueapi.io/v3/content/${id}`)
          .then((response) => {
            this.pushFirstEpsID(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getDetailsProgramIDandEps(program_id, eps_id) {
      try {
        axios
          .get(`https://rtm.glueapi.io/v3/content/${eps_id}`)
          .then((response) => {
            this.assignDetailsWithoutEps(response.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    initSlugObj() {
      var idToCheck;
      if (this.programSlug && this.episodeSlug) {
        idToCheck = this.unslugify(this.episodeSlug);
      } else {
        idToCheck = this.unslugify(this.programSlug);
      }

      // check for main program details due to exclusive thingy
      try {
        axios
          .get(
            `https://rtm.glueapi.io/v3/content?slug=${
              this.programSlug
            }&fields=data.categories,data.images`
          )
          .then((response) => {
            // this.initRTMVODItemDetails(response.data.data[0]);
            this.getCategoryForExclusive(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }

      try {
        axios
          .get(`https://rtm.glueapi.io/v3/content?slug=${idToCheck}`)
          .then((response) => {
            this.initRTMVODItemDetails(response.data.data[0]);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getCategoryForExclusive(obj) {
      const store = [];
      obj.forEach((item) => {
        const category =
          item.data && item.data.categories[0] && item.data.categories[0].id;
        if (category.toString() === "1020" && !this.authenticated) {
          this.lockPlayer = true;
          this.lockPlayerBgImage = this.rtmImgLinkFiltering(
            item.data.images,
            "720x0",
            "title"
          );
        }
      });
    },
    initRTMVODItemDetails(obj) {
      // divide by idscheme (based on type)
      // if let say, movie, then hide the episode list
      // only allow drama to have episode list
      // programSlug,episodeSlug
      // https://rtm.glueapi.io/v3/content?slug=bulan%20di%20kota%20langit%20episode%203
      var vm = this;

      if (vm.episodeSlug) {
        // filter based on news,program,periodic
        // then find programId and episodeId
        vm.episodeId = obj.id;
        if (obj.idSchema == 2006) {
          vm.programId = obj.data.program.id;
        } else if (obj.idSchema == 2008) {
          vm.programId = obj.data.news.id;
        } else if (obj.idSchema == 2010) {
          vm.programId = obj.data.periodic.id;
        }
      } else {
        // filter based on type jgk, pastu get programId
        vm.programId = obj.id;
      }

      if (vm.playerType == "movie" || vm.playerType == "sport") {
        // vm.show_episodes == false;
        vm.getDetailsWithoutEps(vm.programId);
        vm.playerId = vm.programId;
        vm.isMovieOrSport = true;
      } else if (
        (vm.playerType == "program" ||
          vm.playerType == "news" ||
          vm.playerType == "periodic") &&
        !vm.episodeId
      ) {
        vm.show_episodes = true;
        vm.getDetailsWithEps(vm.programId);
      } else if (vm.episodeId && vm.programId) {
        vm.show_episodes = true;
        vm.getDetailsProgramIDandEps(vm.programId, vm.episodeId);
        vm.playerId = vm.episodeId;
      }

      if (vm.playerType == "news") {
        this.playerInit(vm.playerId, "berita");
      } else {
        this.playerInit(vm.playerId, "vod");
      }
    },
    playerInit(id, playerType) {
      var vm = this;
      var target = document.getElementById("vidBox");

      vm.initializePlayerWithAds(id, target, playerType);
      // Vue.nextTick(
      //   function() {
      //     setTimeout(
      //       function() {
      //         var target = document.getElementById("vidBox");

      //         console.log("testing id,", id, playerType, target);
      //         vm.initializePlayerWithAds(id, target, playerType);
      //       }.bind(this),
      //       4000
      //     );
      //     if (vm.vod) {
      //     }
      //   }.bind(vm)
      // );
    },
    setFavoriteVariable() {
      this.isFavoriteActive = !this.isFavoriteActive;
    },
    removeFavorite() {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user_id");
      const programId = this.programId;

      if (user && token) {
        const url = `https://rtm.glueapi.io/v1/user/${user}/content/${programId.toString()}/favourite`;

        $.ajax({
          type: "DELETE",
          url: url,
          contentType: "application/json; charset=utf-8",
          headers: {
            "X-AUTH-TOKEN": `${token}`,
          },
          dataType: "json",
          success: (data) => {
            this.setFavoriteVariable();
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    },
    setFavorite() {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user_id");
      const programId = this.programId;

      if (user && token) {
        const url = `https://rtm.glueapi.io/v3/user/${user}/content/${programId.toString()}/favourite`;

        $.ajax({
          type: "PUT",
          url: url,
          contentType: "application/json; charset=utf-8",
          headers: {
            "X-AUTH-TOKEN": `${token}`,
          },
          dataType: "json",
          success: (data) => {
            this.setFavoriteVariable();
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    },
    checkActiveFavorite(obj) {
      const programId = this.programId;
      obj.forEach((items) => {
        if (
          items.content.slug === programId ||
          items.content.id === programId
        ) {
          this.isFavoriteActive = true;
        }
      });
    },
    checkIsFavorite() {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user_id");

      const config = {
        headers: { "X-AUTH-TOKEN": token },
      };
      try {
        axios
          .get(
            `https://rtm.glueapi.io/v1/user/${user}/content/favourite?fields=slug&limit=300`,
            config
          )
          .then((response) => {
            this.checkActiveFavorite(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeMount() {
    this.initSlugObj();
  },
  mounted() {
    const token = localStorage.getItem("token");

    this.deviceCheck();
    // for favorite, call this checkIsFavorite dlu sebab nk set icon active
    this.checkIsFavorite();
    setTimeout(
      function() {
        this.loads = !this.loads;
      }.bind(this),
      1000
    );

    setTimeout(
      function() {
        if (token) {
          this.initializeRecommendation = true;
        }
      }.bind(this),
      2000
    );
  },
  computed: {
    initPeer() {
      // Our fancy notification (2).
      // peer5
      // peer5.destroy();
      // peer5.init();
    },
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    $("#vidBox").empty();
    // peer5.destroy();
  },
};
</script>

<style>
.pagination {
  width: 100%;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: #000;
  border-top: 1px solid #d9e021;
  border-bottom: 1px solid #d9e021;
  border-radius: 0px !important;
  padding: 16px 4px !important;
}
.pagination li a,
.pagination li.disabled a {
  background-color: #000 !important;
  border-color: unset;
  border: unset !important;
  color: #fff !important;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  padding: 0 !important;
  margin-left: 0 !important;
  margin: 0 4px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
}

.pagination > li:first-child {
  position: absolute;
  left: 4px;
}

.pagination > li:last-child {
  position: absolute;
  right: 4px;
}
.pagination > li:first-child a,
.pagination > li:last-child a {
  border-radius: 8px !important;
  background: #d9e021 !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
  color: #344054 !important;
  padding: 0 8px !important;
  width: fit-content !important;
  font-family: Inter;
  font-size: 16px !important;
  font-weight: 700 !important;
}

.pagination li a:hover,
.pagination li.disabled a:hover {
  background: green;
  border-color: green;
  color: white;
}

.pagination .active a {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background: #d9e021 !important;
  color: #1d2939 !important;
}
/* pagination ends */
</style>

<style scoped>
.belt-margin-bottom-for-players {
  margin-bottom: 2rem;
}

@media only screen and (min-width: 992px) {
  .belt-margin-bottom-for-players {
    margin-bottom: 10rem;
  }
}

.lock-icon-on-player {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.max-width-player {
  max-width: 1440px;
  margin: 0 auto;
}
.pt-vod {
  padding: 0;
  min-height: 80vh;
  overflow: hidden;
}
.drama-title {
  color: #fff;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.details_wrapper {
  background: #171f26;
}
.drama-episode {
  font-family: Inter;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #a8a9ab;
}
.category-wrapper {
  width: auto;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #373946;
}
.category-wrapper span {
  font-family: Inter;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
}
.small-text {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.gray-small-title {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #a8a9ab;
}
.buttonWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.buttonWrapper .icon {
  width: 40px;
  height: 40px;
}
.buttonWrapper .icon img {
  width: 100%;
  height: 100%;
}
.buttonWrapper .label {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.share-btn-wrapper {
  width: auto;
  padding: 12px 20px;
  border-radius: 4px;
  background-color: #dae12f;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-btn-wrapper img {
  height: 18px;
  width: auto;
}
.share-btn-wrapper span {
  font-family: Inter;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  text-align: left;
  color: #000;
  margin-left: 4px;
}
.border-bottom-divider {
  border-bottom: solid 1px #a8a9ab;
}

.tabs {
  max-width: 600px;
  max-height: 400px;
  width: 100%;
  overflow-y: hidden;
}
.tabs input[type="radio"] {
  display: none;
}
.tabs label {
  transition: background 0.4s ease-in-out, height 0.2s linear;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  width: 100%; /* change to 50% once highlight is enabled */
  height: 3em;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  background: #23252b;
  text-align: center;
  line-height: 3em;
  font-family: Inter;
  font-size: 16px;
  font-weight: bold;
  color: #dae12f;
  margin-bottom: 0 !important;
}
.tabs label img {
  width: 16px;
  height: 16px;
}
.tabs label:last-of-type {
  border-bottom: none;
}
.tabs label:hover {
  background: #2d2f34;
  color: #dae12f;
}

.episode-box {
  width: 44px;
  height: 44px;
  padding: 12px;
  border-radius: 3px;
  background-color: #23252b;
}
.episode-box.active {
  background-color: #d2d92e;
}
.episode-box.active span {
  color: #000000;
}
.episode-box span {
  font-family: Inter;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: center;
  color: #fff;
}

#tab1:checked + label,
#tab2:checked + label,
#tab3:checked + label,
#tab4:checked + label {
  background: #2d2f34;
  color: #dae12f;
}

.tab-content {
  position: absolute;
  top: -9999px;
  padding: 10px;
}

.tab-content-wrapper {
  background: #1a1c22;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  max-height: 400px;
  height: auto;
  overflow-y: auto;
}
.play-btn-wrapper {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #dae12f;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
}
.play-btn-wrapper img {
  margin-left: 4px;
  width: 100% !important;
}
.top-10-title {
  font-family: Inter;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.top-1-wrapper {
  padding: 20px;
  background-color: #1d1f25;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.order-text {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #dae12f;
  margin-right: 4px;
}
.episode_active {
  background: rgba(51, 52, 56, 0.76);
}
.eps-title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: #fff;
  padding-right: 8px;
}
.order-title {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.item_img {
  width: 140px;
  height: 188px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
.item_img img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.share-btn {
  width: auto;
  padding: 8px 12px;
  background: #dae12f;
  border-radius: 4px;
  cursor: pointer;
}
.svg-share-wrapper {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.svg-share-wrapper svg {
  width: 100%;
  height: 100%;
}
.share-text {
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.19;
  text-align: left;
  color: #000;
}
.login-lock-wrapper {
  display: flex;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #d9e021;
  background: #d9e021;
  max-width: 300px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  cursor: pointer;
}
.login-lock-button {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media screen and (max-width: 600px) {
  .tab-content-wrapper,
  .tab1-content-wrapper {
    border: none;
    border-radius: 0;
  }
}

#tab1:checked ~ .tab-content-wrapper #tab-content-1,
#tab2:checked ~ .tab-content-wrapper #tab-content-2,
#tab3:checked ~ .tab-content-wrapper #tab-content-3,
#tab4:checked ~ .tab-content-wrapper #tab-content-4 {
  position: relative;
  top: 0px;
}

.m_width_600 {
  max-width: 600px;
}
@media screen and (max-width: 991px) {
}
@media screen and (max-width: 768px) {
  .pt-vod {
    padding: 0;
  }
  .details_wrapper {
    background: #000;
  }
  .small-text {
    font-weight: normal;
  }
  .lock-icon-on-player {
    width: 60px;
    height: 60px;
  }
  .lock-icon-on-player svg {
    width: 100%;
    height: 100%;
  }
}

@media only screen and (max-width: 480px) {
  .pt-vod {
    padding: 0;
  }
  .mb_controller {
    margin-bottom: 30px;
  }
  .lock-icon-on-player {
    width: 40px;
    height: 40px;
  }
  .lock-icon-on-player svg {
    width: 100%;
    height: 100%;
  }
}
</style>
